<template>
  <div id="model-overview">
    <div class="model-overview-box">
      <!--顶部-->
      <div class="top-box">
        <h2 class="title">单模型分析：{{model.name}}</h2>
      </div>
      <!--数据分析-->
      <div class="model-data-analysis-box">
        <div class="data-analysis-top-box">
          <div class="left-box">
            <h2 class="data-analysis-title">访问分析</h2>
          </div>
          <div class="right-box">
             <!--时间-->
            <div class="date-box">
              <span class="date-lable">时间</span>
              <ul class="date-list">
                <li :class="item.isActive ? 'date-item-active' : 'date-item'" v-for="(item,index) in model.dateList" :key="index" @click="ChangeDate(index)">{{item.key}}</li>
              </ul>
            </div>
            <!--日期选择器-->
            <Date-picker type="daterange" format="yyyy-MM-dd" placeholder="选择日期和时间" :value="[model.currentStartDate,model.currentEndDate]"></Date-picker>
          </div>
        </div>
        <p class="time">{{model.currentStartDate}}~{{model.currentEndDate}}</p>
        <!--数据列表-->
        <ul class="data-list">
          <li class="detail-data-info-item" v-for="(item,index) in model.detailDataList" :key="index">
            <span class="detail-data-info-title">{{item.title}}</span>
            <strong class="count">{{item.count}}</strong>
            <div class="other-info-box" v-if="item.isShowOther">
              <span class="percent-lable">环比</span>
              <span class="percent">{{item.percent}}</span>
              <i class="iconfont" :class="item.icon"></i>
            </div>
          </li>      
        </ul>
        <!--图表-->
        <div class="model-data-analysis-map-box">
          <div id="model-map"></div>
        </div>
      </div>
      <!--点位热力图-->
      <div class="point-hot-map-box">
        <h2 class="point-title">点位热力图</h2>
        <span class="time">{{model.currentStartDate}}~{{model.currentEndDate}}</span>
        <div class="model-info-box">
          <!--模型演示区域-->
          <div class="model-demo-box">
          
          </div>
          <!--点位热力值-->
          <div class="point-hot-value-box">
            <Table :columns="model.hotValueColumn" :data="model.hotValue" width="600" max-height="600">
              <template slot-scope="{row}" slot="id">
                <div class="hot-id-box">
                  <div class="hot-id">{{row.id}}</div>  
                </div>
              </template>
               <template slot-scope="{row}" slot="value">
                <div class="hot-value">{{row.value}}</div>
              </template>
            </Table>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name:'modelOverview',
  components:{

  },
  data(){
    return{
      model:{
        name:"南京博物馆",
        detailDataList:[
          {
            title:'模型制作量',
            count:'82',
            percent:'-25.45',
            icon:'icon-statistics-down',
            isShowOther:true
          },
          {
            title:'浏览量(PV)',
            count:'15',
            percent:'-35.00',
            icon:'icon-statistics-down',
            visitModelCount:1,
            isShowOther:true
          },
          {
            title:'访客数(UV)',
            count:'10',
            percent:'11.00',
            icon:'icon-statistics-down',
            isShowOther:true
          },
          {
            title:'平均访问时长',
            count:'00:05:29',
            percent:'无',
            icon:'',
            isShowOther:false
          }
        ],
        dateList: [{
            key: '今天',
            value: 'today',
            isActive: false
          },
          {
            key: '昨天',
            value: 'yesterday',
            isActive: false
          },
          {
            key: '最近7天',
            value: 'past seven days',
            isActive: true
          },
          {
            key: '最近30天',
            value: 'past thirty days',
            isActive: false
          }
        ],
        currentStartDate:'',
        currentEndDate:'',
        data:{
          date: ['2020-09-16','2020-09-17','2020-09-18','2020-09-19','2020-09-20','20202-09-21','20202-09-22'],
          value: [
            {
              data:[0,10,30,45,40,30,60],
              name:'浏览量',
              lineColor:'#37A2DA',
              itemColor:'#37A2DA'
            },
            {
              data:[0,23,40,57,64,45,56],
              name:'访客数',
              lineColor:'#68E0E3',
              itemColor:'#68E0E3'
            },
            {
              data:[0,24,32,45,43,57,66],
              name:'IP数',
              lineColor:'#FFE68B',
              itemColor:'#FFE68B'
            }
          ],
          legend: {
            data:['浏览量','访客数','IP数']
          },
          max:70,
          splitNumber:7,
        },
        hotValueColumn:[
          {
            title:'点位',
            slot:'id',
            align:'center',
            sortable:true
          },
          {
            title:'热力值',
            slot:'value',
            align:'center',
            sortable:true
          }
        ],
        hotValue:[
          {
            id:1,
            value:10
          },
          {
            id:2,
            value:2
          },
          {
            id:22,
            value:40
          },
          {
            id:23,
            value:30
          },
          {
            id:32,
            value:2
          },
          {
            id:12,
            value:12
          },
          {
            id:42,
            value:1
          },
          {
            id:12,
            value:72
          },
          {
            id:52,
            value:12
          },
          {
            id:64,
            value:52
          },
          {
            id:92,
            value:1
          },
          {
            id:34,
            value:22
          },
          {
            id:48,
            value:1
          },
        ]
      }
    }
  },
  created(){
   
  },
  mounted(){
    this.initDate();
    this.initData();
    let modelData = this.model.data;
    this.initECharts('model-map',modelData);
  },
  methods:{
    //初始化时间
    initDate() {
      let date = new Date();
      let currentYear = date.getFullYear();
      let currentMonth = (date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
      let currentDay = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
      this.model.currentStartDate = currentYear + '-' + currentMonth + '-' + (currentDay - 7);
      this.model.currentEndDate = currentYear + '-' + currentMonth + '-' + (currentDay - 1);
    },
    //初始化数据
    initData() {
     this.model.detailDataList.forEach((item, key) => {
        //自动转换图标
        if (item.percent > 0) {
          item.icon = 'icon-statistics-up';
        } else {
          item.icon = 'icon-statistics-down';
        }
        //自动转换单位符号
        if(item.percent != '--' && item.percent >0) {
          item.percent = item.percent + '%';
        }else if (item.percent === 0 ) {
          item.percent = '--';
        }
        //自动转换数值
        if(item.count <= 0 ) {
          item.count = '--';
        }
      });
    },
    //点击切换日期
    ChangeDate(index) {
      this.model.dateList.forEach((key, value) => {
        if (value == index) {
          key.isActive = true;
        } else {
          key.isActive = false;
        }
      });
    },
     //模型制作面板
    initECharts(id,data) {
      var myChart = echarts.init(document.getElementById(id));
      let key = data.date;
      let series = [];
      let legend = data.legend;
      let max = data.max;
      let splitNumber = data.splitNumber;
      data.value.forEach((item,index)=>{
        series.push({
          type: 'line',
          name: item.name,
          showSymbol: true,
          symbolSize:5,
          data: item.data,
          smooth: true,
          lineStyle: {
            color: item.lineColor
          },
          itemStyle: {
            color:item.itemColor
          }
        })
      });
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          lineStyle: {
            color:'#C5C5C5'
          },
          textStyle:{
            color:'#fff'
          },
          padding:10,
        },
        legend:legend,
        xAxis:[{
          data: key,
          boundaryGap: true,
          splitNumber: 1,
          splitLine: { show: false },
          axisLine: {
            lineStyle: {
              color: '#333',
            }
          },
          axisPointer:{
            show:true
          }
        }],
        yAxis:[{
          splitLine: { show: true, lineStyle: { type: 'solid', color: '#ccc' } },
          boundaryGap: false,
          min: 0,
          max: max,
          splitNumber: splitNumber,
          axisTick: {
            length: 1,
            color: '#BFC7CE',
          },
          axisLine: {
            lineStyle: {
              color: '#333',
            }
          }

        }],
        grid: [{
          bottom: '25',
          left: '40',
          width: '95%',
          height: '80%',
        }],
        series: series,
      });
    },
  },
  computed:{

  },
  beforeDestroy(){

  }
}
</script>
<style scoped src="../../assets/css/components/statistics/ModelOverview.css"></style>